import { DataTestType } from '@y42/data-test';

export const DATA_TEST_TYPE_NAMES_TO_UI: Record<
  DataTestType,
  {
    label: string;
    faIcon?: string;
  }
> = {
  [DataTestType.Schema]: {
    label: 'Schema',
    faIcon: 'line-columns',
  },
  [DataTestType.Column]: {
    label: 'Column Test',
    faIcon: 'filter',
  },
  [DataTestType.Unique]: {
    label: 'Unique Key',
    faIcon: '1',
  },
  [DataTestType.LowCode]: {
    label: 'Low-Code Condition',
    faIcon: 'code-simple',
  },
  [DataTestType.ReferentialIntegrity]: {
    label: 'Referential Integrity Test',
    faIcon: 'key',
  },
  [DataTestType.NumRowDrift]: {
    label: 'Row Number Drift',
    faIcon: 'triangle',
  },
};
